/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolCampaignIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-campaign"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M21.4 13.1L19.4 13.1Q18.93 13.1 18.6 12.78Q18.27 12.45 18.27 11.97Q18.27 11.5 18.6 11.18Q18.93 10.85 19.4 10.85L21.4 10.85Q21.88 10.85 22.2 11.18Q22.52 11.5 22.52 11.97Q22.52 12.45 22.2 12.78Q21.88 13.1 21.4 13.1ZM16.8 16.93Q17.07 16.52 17.55 16.48Q18.02 16.43 18.4 16.7L19.98 17.88Q20.35 18.15 20.41 18.61Q20.48 19.07 20.2 19.45Q19.93 19.82 19.46 19.9Q19 19.98 18.63 19.7L17.02 18.52Q16.65 18.25 16.59 17.77Q16.52 17.3 16.8 16.93ZM19.98 6.13L18.4 7.3Q18.02 7.58 17.55 7.51Q17.07 7.45 16.8 7.08Q16.52 6.7 16.6 6.22Q16.68 5.75 17.05 5.47L18.63 4.3Q19 4.03 19.46 4.1Q19.93 4.17 20.2 4.55Q20.48 4.92 20.41 5.39Q20.35 5.85 19.98 6.13ZM4.38 15.25L3.63 15.25Q2.75 15.25 2.11 14.61Q1.48 13.97 1.48 13.1L1.48 10.9Q1.48 10.03 2.11 9.39Q2.75 8.75 3.63 8.75L7.13 8.75L10.43 6.78Q11.07 6.38 11.75 6.75Q12.43 7.13 12.43 7.9L12.43 16.1Q12.43 16.88 11.75 17.25Q11.07 17.63 10.43 17.23L7.13 15.25L6.63 15.25L6.63 18.23Q6.63 18.7 6.3 19.02Q5.97 19.35 5.5 19.35Q5.03 19.35 4.7 19.02Q4.38 18.7 4.38 18.23ZM14.43 15.5L14.43 8.5Q15.15 9.15 15.59 10.05Q16.02 10.95 16.02 12Q16.02 13.05 15.59 13.95Q15.15 14.85 14.43 15.5Z" fill={color} />
    </svg>
  );
}
